import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  Chart,
  BarController, LineController, DoughnutController,
  CategoryScale, LinearScale,
  BarElement, LineElement, PointElement, ArcElement,
  Tooltip, Legend, Filler
} from 'chart.js';

Chart.register(
  BarController, LineController, DoughnutController,
  CategoryScale, LinearScale,
  BarElement, LineElement, PointElement, ArcElement,
  Tooltip, Legend, Filler
);

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Override console methods in production mode
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.error = () => {};
}

document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
});
